import React, { SVGProps } from 'react';
const nearMeFilled = (props: SVGProps<SVGSVGElement>): JSX.Element => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}><path d="M28 4 4 14.04v1.307l9.12 3.533L16.64 28h1.307z" /></svg>;
export default nearMeFilled;